import {TKey} from '@/translations/i18n'
import {
    KnownExclusionReason,
    SiarBulkExportType,
    SiarExportStatus,
    SiarExportsColumn,
    SiarPreviewItemProgressStatus
} from '@/features/projects/siar-bulk-export/types'

export const siarExportTypeToLabel = {
    open_project: 'projects:bulk_siar_export_type_open',
    close_project: 'projects:bulk_siar_export_type_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportTypeToNoEligibleProjectsLabel = {
    open_project: 'projects:bulk_siar_export_no_eligible_projects_open',
    close_project: 'projects:bulk_siar_export_no_eligible_projects_close'
} as const satisfies Record<SiarBulkExportType, TKey>

export const siarExportStatusToLabel = {
    pending: 'projects:bulk_siar_export_status_pending',
    partially_transmitted: 'projects:bulk_siar_export_status_partially_transmitted',
    transmitted: 'projects:bulk_siar_export_status_transmitted'
} as const satisfies Record<SiarExportStatus, TKey>

export const siarExportStatusToBadgeVariant = {
    pending: 'orange',
    partially_transmitted: 'danger',
    transmitted: 'success'
} as const satisfies Record<SiarExportStatus, 'danger' | 'orange' | 'success'>

export const siarPreviewProgressStatusToLabel = {
    to_print: 'projects:status_to_print',
    to_export: 'projects:status_to_export',
    to_transmit: 'projects:status_to_transmit'
} as const satisfies Record<SiarPreviewItemProgressStatus, TKey>

export const siarPreviewProgressStatusToBadgeVariant = {
    to_print: 'primary',
    to_export: 'neutral',
    to_transmit: 'orange'
} as const satisfies Record<SiarPreviewItemProgressStatus, 'neutral' | 'orange' | 'primary' | 'success'>

// Known exclusion reasons mapped to their translation key. The enum is extensible on the
// BE, so unknown values fall back to a generic label via resolveExclusionReasonLabel.
export const exclusionReasonToLabel = {
    missing_initial_evaluation_access: 'projects:siar_exclusion_reason_missing_initial_evaluation_access'
} as const satisfies Record<KnownExclusionReason, TKey>

export const EXCLUSION_REASON_FALLBACK_KEY: TKey = 'projects:siar_exclusion_reason_generic'

export const resolveExclusionReasonLabel = (reason: string): TKey =>
    (exclusionReasonToLabel as Record<string, TKey>)[reason] ?? EXCLUSION_REASON_FALLBACK_KEY

export const siarExportColumnToLabel = {
    exportType: 'projects:bulk_siar_export_column_type',
    period: 'projects:bulk_siar_export_column_period',
    createdAtAndAuthor: 'projects:bulk_siar_export_column_created_at',
    status: 'projects:bulk_siar_export_column_status',
    transmittedAt: 'projects:bulk_siar_export_column_transmitted_at',
    name: 'projects:bulk_siar_export_column_name',
    moreActions: 'commons:actions'
} as const satisfies Record<SiarExportsColumn, TKey>
